import * as tslib_1 from "tslib";
import { navigateToSearchSuggestion } from 'owa-options-orchestration';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./OptionsFull.scss');
var OptionSearchSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(OptionSearchSuggestion, _super);
    function OptionSearchSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSuggestionClick = function () {
            var option = _this.props.option;
            navigateToSearchSuggestion(option.categoryKey, option.subcategoryKey, option.key);
        };
        return _this;
    }
    OptionSearchSuggestion.prototype.render = function () {
        var option = this.props.option;
        return (React.createElement(CommandButton, tslib_1.__assign({}, this.props, { text: strings[option.titleStringKey], onClick: this.onSuggestionClick, className: styles.suggestion })));
    };
    OptionSearchSuggestion = tslib_1.__decorate([
        observer
    ], OptionSearchSuggestion);
    return OptionSearchSuggestion;
}(React.Component));
export default OptionSearchSuggestion;
//# sourceMappingURL=OptionSearchSuggestion.js.map